import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@saas-pages/shared/ui'
import { QrGeneratorTool } from '@/features/qr-generator'
import { useT, type Translations } from '@/shared/i18n'
import { LocalizedProcessingBadge } from '@/shared/ui/LocalizedProcessingBadge'

interface ToolCard {
  href: string
  title: string
  description: string
  cta: string
}

export function ToolsHomePage() {
  const t = useT()

  return (
    <div className="mx-auto max-w-6xl">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
        <div className="max-w-3xl">
          <div className="mb-2 sm:mb-3">
            <LocalizedProcessingBadge variant="local" />
          </div>
          <h1 className="text-2xl font-bold tracking-normal sm:text-4xl">{t.home.hero.title}</h1>
          <p className="mt-2 hidden text-base leading-7 text-muted-foreground sm:block">
            {t.home.hero.description}
          </p>
        </div>
        <Button asChild className="shrink-0" size="sm" variant="outline">
          <a href="/skaner-qr-koda">{t.home.hero.scanAction}</a>
        </Button>
      </div>

      <div className="mt-4 sm:mt-6">
        <QrGeneratorTool />
      </div>

      <section className="mt-8" id="tools">
        <h2 className="text-xl font-semibold tracking-normal">{t.home.tools.title}</h2>
        <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {buildTools(t).map((tool) => (
            <Card key={tool.href} className="flex flex-col rounded-lg">
              <CardHeader className="flex-1">
                <CardTitle className="text-lg">{tool.title}</CardTitle>
                <CardDescription>{tool.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <Button asChild className="w-full" variant="outline">
                  <a href={tool.href}>{tool.cta}</a>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  )
}

function buildTools(t: Translations): ToolCard[] {
  const { generator, barcode, barcodeScanner, scanner } = t.home.tools
  return [
    { href: '/qr-kod', ...generator },
    { href: '/skaner-qr-koda', ...scanner },
    { href: '/generator-shtrih-kodov', ...barcode },
    { href: '/skaner-shtrih-koda', ...barcodeScanner },
  ]
}
